const generateUniqueId = (prefix = "id") => {
  return `${prefix}-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
}

const fumCustomBogos = () => {
  const giftItemsEl = document.getElementById("fg-gift-items"); 

  const gliderTracks = giftItemsEl.getElementsByClassName("glider-track");

  let bogoItems = [];
  Array.from(gliderTracks).forEach(track => {
    // Perform actions with each `track` element here
    const productTitle = track.getElementsByClassName("product-title")[0]?.innerText;
    const productUrl = track.getElementsByClassName("gift-original-url")[0]?.href ?? "#";
    const originalPrice = track.querySelector("original-price del");
    const discountedPrice = track.querySelector("gift-price");
    const buttonEl = track.getElementsByClassName("btn-add-to-cart")[0];
    buttonEl.setAttribute("data-element-id", generateUniqueId("fum-bogos"));
    const buttonText = buttonEl.innerText ?? "";
    const buttonElId = buttonEl.getAttribute("data-element-id");

    const serializeItems = {
      productTitle,
      productUrl,
      originalPrice,
      discountedPrice,
      button: {
        _id: buttonElId,
        el: buttonEl,
        text: buttonText
      }
    }

    bogoItems.push(serializeItems);
  });


  clearFumCustomBogosDrawer();
  let appendHtml = "";
  bogoItems.forEach((item, idx) => {
    // let _html = "";
    if (item.productTitle != null) {
      // _html += `<div class="fum-bogos-item" 
      //   data-product-title="${item.productTitle}" 
      //   data-product-url="${item.productUrl}"
      //   data-original-price="${item.originalPrice}"
      //   data-discounted-price="${item.discountedPrice}"
      //   data-button-el="${item.button.el.innerHTML}"
      //   data-button-text="${item.button.text}"
      // ></div>`;

      processFumCustomBogosDrawer(item);
    }

    
    console.log("BOGO_ITEM", item);
  });

  // document.getElementById("fum-bogos-items").innerHTML += appendHtml;
}

const clearFumCustomBogosDrawer = (bogosItemsId = "fum-bogos-items") => {
  document.getElementById(bogosItemsId).innerHTML = "";
}

const processFumCustomBogosDrawer = (item, bogosItemsId = "fum-bogos-items") => {
  let _html = "";

  if (item.productUrl?.includes("holiday-journey-pack")) {
    if (item.button.text != "") {
      _html += `<div class="fum-bogos-item" style="background-image: url('//tryfum.com/cdn/shop/t/150/assets/FUMCartImageFull.png?v=81302959017447860741731109140'); width: 100%; height: 55%; border-radius: 10px; background-size: cover; background-position: center;">`;
        _html += `<div class="fum-bogos-item--inner">`;
          _html += `<button class="large solid fum-bogos-button" style="align-self: end; margin-bottom: 20px;" onClick="fumBogosActionBtn('${item.button._id}')">${item.button.text}</button>`
        _html += `</div>`;
      _html += `</div>`
    }
  }

  if (_html != "" || _html != null || _html != undefined) {
    document.getElementById(bogosItemsId).innerHTML += _html;
  }
  
}

const fumBogosActionBtn = (_id) => {
  if (_id != null) {
    const _button = document.querySelector(`button[data-element-id="${_id}"]`);
    _button.click();
  }
}